import { productsState } from '@/states/products.state';
import { storeAtom } from '@/states/store.state';
import { Store } from '@/types/store';
import { atom } from 'jotai';

export type VatRatesValue = {
  vatRates: number[];
  uniqueVatRates: number[];
};

export const vatRatesAtom = atom<VatRatesValue>((get) => {
  const products = get(productsState);
  const store = get(storeAtom);

  const vatRates = products
    .filter((product) => product.activeVersion.isSelected)
    .filter(
      (product) =>
        !product.activeVersion.hasVatMargin &&
        product.activeVersion.vatRate !== null &&
        product.activeVersion.vatRate !== undefined &&
        store === Store.FR
    )
    .map((product) => product.activeVersion.vatRate!);

  const uniqueVatRates = Array.from(new Set(vatRates))
    .filter((rate): rate is number => rate !== null && rate !== undefined)
    .sort((a, b) => a - b);

  return {
    vatRates,
    uniqueVatRates,
  };
});
